/**
 * Формы сезонного декора в рамке 24×24, общие для фона (canvas, Path2D) и карты
 * подписки (SVG). Рисованы руками, без шрифтовых эмодзи: эмодзи на каждой
 * платформе свои, и лист на Android выглядел бы иначе, чем на iPhone.
 */
export const LEAF_MAPLE =
  'M12 1.5l1.6 3.6 2.6-1.3-.6 3.8 3.4-.9-1.2 2.6 3.2 1.4-3.4 2.4.8 1.8-3.8-.4.4 3.6-3-2-.8 4.6h-.6l-.8-4.6-3 2 .4-3.6-3.8.4.8-1.8-3.4-2.4 3.2-1.4-1.2-2.6 3.4.9-.6-3.8 2.6 1.3z';
export const LEAF_OVAL = 'M12 2C6.2 6 4.6 12 7 16.8c1.5 3.1 3.3 4.4 5 5.2 1.7-.8 3.5-2.1 5-5.2C19.4 12 17.8 6 12 2z';
/** Прожилка овального листа и черенок кленового. */
export const LEAF_OVAL_VEIN = 'M12 4.5V22';
export const LEAF_MAPLE_STEM = 'M12 18v5.5';

/** Тёплая гамма листопада: от охры до бордо. */
export const LEAF_COLORS = ['#e0912f', '#d4572a', '#e9b23c', '#a8401f', '#c97a26'];

/** Тыква для вылета по нажатию в Хэллоуин: три дольки и хвостик. */
export const PUMPKIN =
  'M12 7c-1.2 0-2.2.3-3 .8C7.9 7.3 6.8 7 5.8 7 3 7 1.5 9.8 1.5 13.5S3 20 5.8 20c1 0 2.1-.3 3.2-.8.8.5 1.8.8 3 .8s2.2-.3 3-.8c1.1.5 2.2.8 3.2.8 2.8 0 4.3-2.8 4.3-6.5S21 7 18.2 7c-1 0-2.1.3-3.2.8-.8-.5-1.8-.8-3-.8z';
export const PUMPKIN_STEM = 'M12 7.5c0-2 .6-3.6 2.4-4.5';
export const PUMPKIN_LOBES = 'M9 8c-1.4 2.6-1.4 8.6 0 11.2M15 8c1.4 2.6 1.4 8.6 0 11.2';

/** Цвета конфетти и огоньков: те же, что у гирлянды на карте. */
export const FESTIVE_COLORS = ['#ff5a5f', '#ffd05a', '#5ad1ff', '#7ef09a'];

/** Фантики хэллоуинских конфет. */
export const CANDY_COLORS = ['#ff5a8a', '#8b6cff', '#36c2b4', '#ffc23d'];
